import { Directive, HostListener } from '@angular/core';
import { IonSelect } from '@ionic/angular/standalone';

// https://stackoverflow.com/a/65543138

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'ion-select[autoscroll]',
  standalone: true
})
export class AutoscrollSelectDirective {
  constructor(private ionSelect: IonSelect) {}

  @HostListener('click')
  scrollSoon(): void {
    let keBab = '';
    switch (this.ionSelect.interface) {
      case 'alert':
        keBab = 'Alert';
        break;
      case 'action-sheet':
        keBab = 'ActionSheet';
        break;
      case 'popover':
        keBab = 'Popover';
        break;
    }

    if (keBab) {
      window.addEventListener(
        `ion${keBab}DidPresent`,
        (e) => {
          const parent: Element = e.target as any;
          const scrollTarget =
            keBab === 'ActionSheet'
              ? parent.querySelector('.action-sheet-selected')
              : parent.querySelector('[aria-checked=true]')?.closest('.select-interface-option');
          if (scrollTarget) {
            scrollTarget.scrollIntoView();
          }
        },
        { once: true }
      );
    }
  }
}
